import React from 'react';
import {
  TaskHeader,
  TaskStats,
  TaskSidebar,
  TaskList,
  TaskModal,
  QuickTaskModal,
  useTasksData
} from '../components/tasks';

export default function TasksPage() {
  const {
    // Data
    tasks,
    groups,
    stats,
    loading,
    locations,
    users,
    currentUser,

    // Filters
    selectedCategory,
    setSelectedCategory,
    selectedGroup,
    setSelectedGroup,
    selectedStatus,
    setSelectedStatus,
    searchQuery,
    setSearchQuery,
    selectedLocation,
    setSelectedLocation,
    showAllTasks,
    setShowAllTasks,

    // Modals
    showAddModal,
    setShowAddModal,
    showQuickTaskModal,
    setShowQuickTaskModal,
    showEditModal,
    editingTask,
    openEditModal,
    closeEditModal,

    // Actions
    fetchData,
    toggleTask,
    deleteTask
  } = useTasksData();

  return (
    <div>
      <TaskHeader
        currentUser={currentUser}
        locations={locations}
        selectedLocation={selectedLocation}
        setSelectedLocation={setSelectedLocation}
        showAllTasks={showAllTasks}
        setShowAllTasks={setShowAllTasks}
        onQuickTask={() => setShowQuickTaskModal(true)}
        onNewTask={() => setShowAddModal(true)}
      />

      <div style={{ padding: '16px' }}>
        <TaskStats
          stats={stats}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
        />

        <div style={{ display: 'flex', gap: '16px' }}>
          <TaskSidebar
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            groups={groups}
            selectedGroup={selectedGroup}
            setSelectedGroup={setSelectedGroup}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
          />

          <TaskList
            tasks={tasks}
            loading={loading}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onToggle={toggleTask}
            onEdit={openEditModal}
            onDelete={deleteTask}
            onAddNew={() => setShowAddModal(true)}
          />
        </div>
      </div>

      {/* Quick Task Modal */}
      {showQuickTaskModal && (
        <QuickTaskModal
          onClose={() => setShowQuickTaskModal(false)}
          onSave={() => { setShowQuickTaskModal(false); fetchData(); }}
          currentUser={currentUser}
          selectedLocation={selectedLocation}
        />
      )}

      {/* Add Task Modal */}
      {showAddModal && (
        <TaskModal
          onClose={() => setShowAddModal(false)}
          onSave={() => { setShowAddModal(false); fetchData(); }}
          groups={groups}
          locations={locations}
          users={users}
          currentUser={currentUser}
          selectedLocation={selectedLocation}
          defaultCategory={selectedCategory !== 'wszystkie' ? selectedCategory : 'dzis'}
        />
      )}

      {/* Edit Task Modal */}
      {showEditModal && editingTask && (
        <TaskModal
          task={editingTask}
          onClose={closeEditModal}
          onSave={() => { closeEditModal(); fetchData(); }}
          groups={groups}
          locations={locations}
          users={users}
          currentUser={currentUser}
          selectedLocation={selectedLocation}
        />
      )}
    </div>
  );
}
